import React from "react";
import classNames from "classnames";
import styles from "./DeleteRowButton.less";

export default function DeleteRowButton({
  className,
  innerAlign = "right",
  disabled = false,
  whiteBackground = false,
  absolute = true,
  ...props
}) {
  return (
    <a
      className={classNames("c-EditButton", styles["DeleteRowButton"], {
        [className || ""]: true,
        disabled,
        [styles[`DeleteRowButton--absolute`]]: absolute,
        [styles[`DeleteRowButton--innerAlign-${innerAlign}`]]: true,
        [styles[`DeleteRowButton--whiteBackground`]]: whiteBackground,
      })}
      {...props}
    >
      <i className="icon material-icons">close</i>
    </a>
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/DeleteRowButton.jsx